import React from 'react';
import clsx from 'clsx';
import styles from './DashboardCol.module.css';

export interface DashboardColProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const DashboardCol: React.FC<DashboardColProps> = ({ className, children, ...props }) => {
  return (
    <div className={clsx(styles.dashboardCol, className)} {...props}>
      {children}
    </div>
  );
};

export default DashboardCol;
